import { AbstractCommand } from 'src/models/command';

interface CreateDocumentCategoryCommandPayload {
	documentId: number;
	idoId: number;
	idoInstanceId: number;
	isGlobal: boolean;
	name: string;
}

class CreateDocumentCategoryCommand extends AbstractCommand {
	readonly name: string;

	public constructor(payload: CreateDocumentCategoryCommandPayload) {
		super();
		this.name = payload.isGlobal
			? 'IFS_Desktop_Command_Command_Legacy_Modules_Document_CreateGlobalDocumentCategory'
			: 'IFS_Desktop_Command_Command_Legacy_Modules_Document_CreateDocumentCategory';
		this.parameters = {
			documentId: payload.documentId,
			idoId: payload.idoId,
			idoInstanceId: payload.idoInstanceId,
			name: payload.name,
		};
	}
}

export { CreateDocumentCategoryCommand };
